import produce from "immer";
import {
  AUTH_AUTHENTICATE_REQUEST,
  AUTH_AUTHENTICATE_SUCCESS,
  AUTH_AUTHENTICATE_FAILURE,
  AUTH_LOGIN_REQUEST,
  AUTH_LOGIN_SUCCESS,
  AUTH_LOGIN_FAILURE,
  AUTH_LOGOUT_REQUEST,
  AUTH_LOGOUT_FAILURE,
  AUTH_REFRESH_JWT_SUCCESS,
  AUTH_REFRESH_JWT_REQUEST,
  AUTH_REFRESH_JWT_FAILURE,
  AUTH_JWT_EXPIRED,
} from "../actions/types";

const authInitState = {
  isAuthenticated: false,
  user: {
    email: null,
    firstName: null,
    lastName: null,
    roles: [],
    groups: [],
  },
  token: null,
  error: null,
  loading: false,
};

export const auth = (state = authInitState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      // ---------------- REQUEST ----------------
      case AUTH_AUTHENTICATE_REQUEST:
      case AUTH_LOGIN_REQUEST:
      case AUTH_LOGOUT_REQUEST:
        draft.loading = true;
        break;
      // ---------------- SUCCESS ----------------
      case AUTH_AUTHENTICATE_SUCCESS:
      case AUTH_LOGIN_SUCCESS:
        draft.loading = false;
        draft.isAuthenticated = true;
        draft.token = action.token;
        draft.user.id = action.user.id;
        draft.user.name = action.user.name;
        draft.user.email = action.user.email;
        draft.user.firstName = action.user.first_name;
        draft.user.lastName = action.user.last_name;
        draft.user.roles = action.user.roles;
        draft.user.groups = action.user.groups;
        break;
      // ---------------- FAILURE ----------------
      case AUTH_AUTHENTICATE_FAILURE:
      case AUTH_LOGIN_FAILURE:
      case AUTH_LOGOUT_FAILURE:
        draft.loading = false;
        draft.error = action.error;
        break;
      // ---------------- UTILS ----------------
      case AUTH_JWT_EXPIRED:
        draft.isAuthenticated = false;
        break;
      // ---------------- NOP ----------------
      case AUTH_REFRESH_JWT_REQUEST:
      case AUTH_REFRESH_JWT_SUCCESS:
      case AUTH_REFRESH_JWT_FAILURE:
        break;
      default:
    }
  });
